import React, { Component } from 'react';
import {
    Col, Row, Form, Button,
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeLang } from '../../../../Redux/Action/LoginAction'
import { SendingEmail } from '../../../../Redux/Action/ForgetAction'
import RenderField from '../../../../Components/Fields/fields'
import { Inputs } from './inputSettings'
import validate from './validation';
import String from '../../../../Assets/locals'
import '../ResetPassword/resetPassword.css'

class ConfirmationCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            closeAll: false,
            RedirectTo: false,
            code: null,
            codeErr: false,
            userCode: null
        };


    }
    componentWillMount() {
        let lang = localStorage.getItem("JazanLanguage") ? JSON.parse(localStorage.getItem("JazanLanguage")) : null
        if (lang) {
            this.props.changeLang(lang)
        } else {
            this.props.changeLang(JSON.parse(localStorage.getItem("ar")))
        }
    }


    onSubmit = (values) => {
        let data = {
            email: localStorage.getItem("JazanEmail"), 
            code: values.code,
            type: localStorage.getItem("JazanType")
        }
        this.props.SendingEmail(data, this.props.lang)
    }
    render() {
        const { handleSubmit, submitting } = this.props
        String.setLanguage(this.props.lang)
        let lang = this.props.lang


        return (
            // <div>
            //     <div className="loading-bar" >
            //         <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "#006B30" }} />
            //     </div>

            //     <div className="bg-login">
            //         <div className="container">
                        <div className="login-form" >
                            <Row>
                                <Col md="12" className="forgot-title" > <h4> {String.codeTitle} </h4> </Col>

                            </Row>
                            <Row style={{ padding: '0 2%' }}>
                                <Col md="12" lg="12">
                                    <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        {
                                            Inputs.map((row, index) => {
                                                return (
                                                    <Row key={index} style={{ direction: lang === "ar" ? "rtl" : 'ltr', margin: '10px 24%' }}>
                                                        {
                                                            row.map((element, index) => {
                                                                return (
                                                                    <Field key={index}
                                                                        lang={lang}
                                                                        type={element.type}
                                                                        name={element.name}
                                                                        component={RenderField}
                                                                        label={lang === "ar" ? element.label.ar : element.label.en}
                                                                        placeholder={element.placeholder ? (lang === "ar" ? element.placeholder.ar : element.placeholder.en) : ""}
                                                                        options={element.options}
                                                                        optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                                        size={element.size}
                                                                    // title={lang === "ar" ? element.title.ar : element.title.en}
                                                                    />
                                                                )
                                                            })

                                                        }

                                                    </Row>
                                                )
                                            })
                                        }


                                        <Col md="12" className="login-submit-Btn" style={{ marginTop: '2%', textAlign: 'center' }} id="loginBtn">
                                            <Button type="submit" className="btn submitBtn" disabled={submitting} >
                                                {String.submitButton}
                                                {/* {String.loginBtn}  */}
                                            </Button>
                                        </Col>
                                    </Form>

                                </Col>
                            </Row>
                        </div>
            //         </div>
            //     </div>
            // </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        lang: state.login.language,
        token: state.login.token
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        SendingEmail,
        changeLang
        // visit
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(ConfirmationCode));
